import styled, { keyframes } from 'styled-components';

const fade = keyframes`
  from {
    margin-top: -100px;
    opacity: 0;
  }
  to {
    margin-top: 0;
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  0% {
    display: flex;
    margin-left: 0;
    opacity: 1;
  }
  80% {
    margin-left: -100px;
    opacity: 0;
    height: auto;
  }
  100% {
    margin-left: -100px;
    opacity: 0;
    height: 0;
  }
`;

export const RemovableItemWrapper = styled.div<{ $remove: boolean }>`
  display: flex;
  animation: ${({ $remove }) => ($remove ? fadeOut : fade)} 300ms ease;
  margin-top: 15px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
